import { ADMINISTRATION_PERSON_USER_URL, API_PERSON } from "globals/constants";
import { buildSearchParams, request } from "utils/proxy";


export const person = {
	/**
	 * @param {{ id: string }} params
	 * @param {{}?} options
	 */
	get: (params, options) => {
		const { id, includeInactiveAffiliations } = params || {};
		const url = !!includeInactiveAffiliations
			? `${API_PERSON}/${id}?includeInactiveAffiliations=true`
			: `${API_PERSON}/${id}`;

		return request(url, options);
	},

	/**
	 * Retrieve a list of persons.
	 *
	 * @param {object} params - Query parameters for filtering and pagination.
	 * @param {{}?} options - Request options.
	 * @param {number} [params.page] - The page number for pagination.
	 * @param {number} [params.size] - The number of items per page.
	 * @param {string[]} [params.search] - A search term for filtering.
	 *
	 * @returns {Promise<{}[]>} A Promise that resolves with the list of persons.
	 */
	findAll: (params, options) =>
		request(`${API_PERSON}${buildSearchParams(params)}`, options),

	user: id => {
		return request(`${ADMINISTRATION_PERSON_USER_URL}/${id}`);
	}
};
